"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToastConfig = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactSdk = require("@100mslive/react-sdk");
var _reactIcons = require("@100mslive/react-icons");
var _reactUi = require("@100mslive/react-ui");
var _hms = require("../../hms");
var _constants = require("../../common/constants");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var isChatOpen = function isChatOpen() {
  return _hms.hmsStore.getState((0, _reactSdk.selectAppData)(_constants.APP_DATA.sidePane)) === _constants.SIDE_PANE_OPTIONS.CHAT;
};
var ChatAction = /*#__PURE__*/_react["default"].forwardRef(function (_, ref) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Button, {
    outlined: true,
    as: "div",
    variant: "standard",
    css: {
      w: "max-content"
    },
    onClick: function onClick() {
      _hms.hmsActions.setAppData(_constants.APP_DATA.sidePane, _constants.SIDE_PANE_OPTIONS.CHAT);
    },
    ref: ref,
    children: "Open Chat"
  });
});
var ToastConfig = {
  PEER_LIST: {
    single: function single(notification) {
      var _notification$data;
      if (notification.data.length === 1) {
        var _notification$data$;
        return {
          title: "".concat((_notification$data$ = notification.data[0]) === null || _notification$data$ === void 0 ? void 0 : _notification$data$.name, " joined"),
          icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.PersonIcon, {})
        };
      }
      return {
        title: "".concat((_notification$data = notification.data[notification.data.length - 1]) === null || _notification$data === void 0 ? void 0 : _notification$data.name, " and ").concat(notification.data.length - 1, " others joined"),
        icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.PersonIcon, {})
      };
    },
    multiple: function multiple(notifications) {
      return {
        title: "".concat(notifications[0].data.name, " and ").concat(notifications.length - 1, " others joined"),
        icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.PersonIcon, {})
      };
    }
  },
  PEER_JOINED: {
    single: function single(notification) {
      var _notification$data2;
      return {
        title: "".concat((_notification$data2 = notification.data) === null || _notification$data2 === void 0 ? void 0 : _notification$data2.name, " joined"),
        icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.PersonIcon, {})
      };
    },
    multiple: function multiple(notifications) {
      return {
        title: "".concat(notifications[notifications.length - 1].data.name, " and ").concat(notifications.length - 1, " others joined"),
        icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.PersonIcon, {})
      };
    }
  },
  PEER_LEFT: {
    single: function single(notification) {
      var _notification$data3;
      return {
        title: "".concat((_notification$data3 = notification.data) === null || _notification$data3 === void 0 ? void 0 : _notification$data3.name, " left"),
        icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.PersonIcon, {})
      };
    },
    multiple: function multiple(notifications) {
      return {
        title: "".concat(notifications[notifications.length - 1].data.name, " and ").concat(notifications.length - 1, " others left"),
        icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.PersonIcon, {})
      };
    }
  },
  METADATA_UPDATED: {
    single: function single(notification) {
      var _notification$data4;
      return {
        title: "".concat((_notification$data4 = notification.data) === null || _notification$data4 === void 0 ? void 0 : _notification$data4.name, " raised hand"),
        icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.HandIcon, {})
      };
    },
    multiple: function multiple(notifications) {
      var _notifications$data;
      return {
        title: "".concat((_notifications$data = notifications[notifications.length - 1].data) === null || _notifications$data === void 0 ? void 0 : _notifications$data.name, " and ").concat(notifications.length - 1, " others raised hand"),
        icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.HandIcon, {})
      };
    }
  },
  NEW_MESSAGE: {
    single: function single(notification) {
      var _notification$data5;
      return {
        title: "New message from ".concat((_notification$data5 = notification.data) === null || _notification$data5 === void 0 ? void 0 : _notification$data5.senderName),
        icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.ChatIcon, {}),
        action: isChatOpen() ? null : /*#__PURE__*/(0, _jsxRuntime.jsx)(ChatAction, {})
      };
    },
    multiple: function multiple(notifications) {
      return {
        title: "".concat(notifications.length, " new messages"),
        icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.ChatIcon, {}),
        action: isChatOpen() ? null : /*#__PURE__*/(0, _jsxRuntime.jsx)(ChatAction, {})
      };
    }
  },
  RECONNECTED: {
    single: function single() {
      return {
        title: "You are now connected",
        icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.ConnectivityIcon, {}),
        variant: "success",
        duration: 3000
      };
    }
  },
  RECONNECTING: {
    single: function single() {
      return {
        title: "You are offline for now. while we try to reconnect, please check\n        your internet connection.\n      ",
        icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.PoorConnectivityIcon, {}),
        variant: "warning",
        duration: 10000
      };
    }
  }
};
exports.ToastConfig = ToastConfig;